const styles = (theme) => ({
  mcqContainer: {
    display: "flex",
    flexDirection: "column",
    height: "304px",
    padding: 12,
    overflow: "auto",
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  addOption: {
    color: theme.HeaderSelectedText,
    backgroundColor: "transparent",
    boxShadow: "none",
    width: 105,
    fontWeight: 600,
    marginTop: 12,
    letterSpacing: "1px",
    "&:hover": {
      backgroundColor: theme.btnHoverColor,
    },
    "&:focus": {
      backgroundColor: theme.btnHoverColor,
    },
  },
  sendMessage: {
    backgroundColor: theme.HeaderSelectedText,
    boxShadow: "none",
    fontWeight: 600,
    width: 99,
    marginTop: 24,
    marginLeft: 20,
    letterSpacing: "1px",
  },
  iconStyle: {
    cursor: "pointer",
    fontSize: "18",
    padding: 2,
    marginLeft: 8,
  },
  radioStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  textField: {
    margin: "0 6 0 0",
    width: "100%",
  },
  radioIcon: {
    color: theme.iconColor,
    fontSize: 16,
    margin: "8 8 2 0",
  },
  optionInputField: {
    padding: "12 0 4 4",
    fontWeight: 400,
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor
  },
  messageInputField: {
    padding: "8",
    fontWeight: 500,
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "flex-end",
  },
  textFieldMultiline: {
    fontSize: theme.headerTextFontSize,
    padding: 12,
    color: theme.iconColor
  },
  errorMsg: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
  },
  optionContainer: {
    display: "flex",
    flexDirection: "column",
  }
});

export default styles;